import { request } from "@/lib/request";
import { useState } from "react";
import { toast } from "sonner";
import { UserSubscription } from "@/lib/types";

const URLMap = {
  change: "payment/subscriptions/update",
  cancel: "payment/subscriptions/cancel",
  manage: "payment/subscriptions/portal",
};

export const usePaymentModification = ({
  subscription,
  onSuccess,
  onError,
}: {
  subscription: UserSubscription;
  onSuccess?: (data: unknown) => void;
  onError?: (error: unknown) => void;
}) => {
  const [updateLoading, setUpdateLoading] = useState(false);
  const [changeLoading, setChangeLoading] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);

  const handleMethod = (method: "change" | "cancel" | "manage") => async () => {
    if ([updateLoading, changeLoading, cancelLoading].some(l => l)) {
      return;
    }

    if (method === "change") {
      setChangeLoading(true);
    }
    if (method === "cancel") {
      setCancelLoading(true);
    }
    if (method === "manage") {
      setUpdateLoading(true);
    }

    try {
      const res = await request
        .get(`/${URLMap[method]}/${subscription.id}`)
        .catch(err => {
          throw new Error(err.response?.data.message);
        });

      if (onSuccess) {
        onSuccess(res.data.data);
      } else {
        window.location.href = res.data.data.redirect;
      }
    } catch (error) {
      if (onError) {
        onError(error);
      } else {
        toast.error(
          error instanceof Error ? error.message : "An error occurred",
        );
      }
    } finally {
      if (method === "change") {
        setChangeLoading(false);
      }
      if (method === "cancel") {
        setCancelLoading(false);
      }
      if (method === "manage") {
        setUpdateLoading(false);
      }
    }
  };

  return { updateLoading, changeLoading, cancelLoading, handleMethod };
};
